import { Dialog, DialogActions, DialogContent } from "@mui/material";
import InfoCard from "@/ui/InfoCard";
import type { LottieProps } from "react-lottie-player";
import DialogCloseButton from "./DialogCloseButton";

export default function InfoCardDialog({
  onClose,
  open,
  title,
  description,
  lottieOptions,
  imageSrc,
  imageAlt,
  children,
  actions,
  disableClose = false,
}: {
  onClose: () => void;
  open: boolean;
  title: string;
  description: string;
  lottieOptions?: LottieProps;
  imageAlt?: string;
  imageSrc?: string;
  children?: React.ReactNode;
  /**
   * Pinned below the scrollable card, so it stays visible however tall the
   * card grows (r-2002). Use it for the dialog's call to action.
   */
  actions?: React.ReactNode;
  disableClose?: boolean;
}) {
  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth={true}
      keepMounted={false}
      onClose={(_, reason) =>
        reason !== "backdropClick" && disableClose && onClose()
      }
    >
      {!disableClose ? <DialogCloseButton onClick={onClose} /> : null}
      {/* DialogContent owns the scrolling: without it the Card (overflow
          hidden) is clipped by the paper's max height and anything below the
          fold is unreachable. */}
      <DialogContent sx={{ p: 0 }}>
        <InfoCard
          title={title}
          description={description}
          lottieOptions={lottieOptions}
          imageSrc={imageSrc}
          imageAlt={imageAlt}
        >
          {children}
        </InfoCard>
      </DialogContent>
      {actions ? (
        <DialogActions
          disableSpacing
          sx={{
            flexDirection: "column",
            gap: 3,
            mx: 3,
            px: 0,
            py: 3,
            borderTop: 1,
            borderColor: "divider",
          }}
        >
          {actions}
        </DialogActions>
      ) : null}
    </Dialog>
  );
}
